import { render, staticRenderFns } from "./OnlineClassIndex.vue?vue&type=template&id=7f2e05bc&scoped=true&"
import script from "./OnlineClassIndex.vue?vue&type=script&lang=js&"
export * from "./OnlineClassIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e05bc",
  null
  
)

export default component.exports